import { allPropKeys } from '../types/index.esm.js';
export { allPropKeys, backdropFilterPropKeys, backgroundPropKeys, borderPropKeys, effectsPropKeys, filterPropKeys, flexboxPropKeys, gridPropKeys, interactivityPropKeys, layoutPropKeys, psuedoPropKeys, sizingPropKeys, spacingPropKeys, svgPropKeys, tablePropKeys, textPropKeys, transformPropKeys, transitionsPropKeys } from '../types/index.esm.js';

var additionalPropKeys = ['dangerouslySetClassName'];
var commonPropKeys = /*#__PURE__*/[].concat(allPropKeys, additionalPropKeys);

export { commonPropKeys };
//# sourceMappingURL=types.esm.js.map
